import React from 'react';
import {
	Grid,
	Paper,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const BaseLayout = (props) => {

	const classes = useStyles();
	return (
		<Grid container xs={12}>
			<Grid item xs={12}>
				<Paper elevation={3}>
					<Grid item xs={12} className={classes.padding}> 
						{props.children}
					</Grid>
				</Paper>
			</Grid>
		</Grid>
	
	);
}

export default BaseLayout;

const useStyles = makeStyles((theme) =>
	createStyles({
		paddingTop: theme.spacing(1)
	}),
);

